import * as React from "react";
import { forwardRef } from "react";
const Svg24Px = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1122_16)" }, /* @__PURE__ */ React.createElement("path", { d: "M6 11H18V13H6V11Z", fill: "currentColor" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1122_16" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white" }))));
const ForwardRef = forwardRef(Svg24Px);
export default ForwardRef;
